import { Usuario } from './usuario';
import { DomainSerializer } from '../../../common/domain.serializer';


export class UsuarioSerializer extends DomainSerializer<Usuario> {
  
}
